import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./app"
import "./app/styles/index.css"
import { installSpoilerRehide } from "./shared/lib/spoiler"
import {
	captureTelegramInitData,
	expandTelegramMiniApp,
	storedTelegramInitData,
} from "./shared/lib/telegram-mini-app"

captureTelegramInitData()
installSpoilerRehide()
if (storedTelegramInitData()) expandTelegramMiniApp()

const root = document.getElementById("root")
if (!root) throw new Error("Не найден #root: проверьте src/index.html")

createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
)
